import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import Grid from '@mui/material/Grid2';
import { Icon } from '@iconify/react';
import { Download04Icon } from 'hugeicons-react';
import KnowledgeBaseApi from '../../../../infrastructure/knowledge-base-api';
import { toast } from 'react-toastify';
export function KnowledgeBaseDocumentPopUp({ openDialog, title, onClose, files }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const downloadDocument = async (fileName, documentPath, documentId) => {
        try {
            // Extract folderName (first part) and filename (rest of path including subfolders)
            // e.g., "KnowledgeBase/VDKGroep/file.pdf" -> folderName="KnowledgeBase", filename="VDKGroep/file.pdf"
            const pathParts = documentPath.split('/');
            const folderName = pathParts[0]; // First part is the main folder
            const filename = pathParts.slice(1).join('/'); // Rest is the filename (may include subfolders)
            const response = await KnowledgeBaseApi.downloadKnowledgeBaseDocument(folderName, filename);
            // Convert base64 to blob
            const base64 = response.data.file;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            toast.error(t('downloadFailed') || 'Failed to download document');
        }
    };
    return (_jsxs(Dialog, { maxWidth: 'sm', fullWidth: true, sx: {
            '& .MuiDialog-paper': {
                overflow: 'hidden',
                backgroundColor: '#212B36'
            }
        }, open: openDialog, onClose: onClose, children: [_jsxs(DialogTitle, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'sticky',
                    top: 0,
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    zIndex: 1000,
                    padding: '16px'
                }, children: [title + ' ' + t('documents'), _jsx(IconButton, { "aria-label": 'close', onClick: onClose, sx: {
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.text.primary
                        }, children: _jsx(CloseOutlined, {}) })] }), _jsx(DialogContent, { sx: {
                    maxHeight: 'calc(100svh - 32px)',
                    overflowY: 'auto',
                    backgroundColor: theme.palette.background.paper
                }, children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: '20px', children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: '12px', children: _jsx(Grid, { container: true, spacing: 1, children: files.map((file, index) => (_jsxs(Box, { sx: {
                                    backgroundColor: theme.palette.background.default,
                                    boxShadow: theme.customShadows.card,
                                    padding: '8px 12px',
                                    borderRadius: 1
                                }, gap: 1, width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', flex: '1 auto', children: [_jsx(Grid, { size: { xs: 12, md: 8 }, children: _jsxs(Box, { display: 'flex', flexDirection: 'row', children: [_jsx(Icon, { icon: 'material-icon-theme:pdf', width: 40, height: 40, color: 'default' }), _jsx(Box, { display: 'flex', flexDirection: 'column', children: _jsx(Tooltip, { title: file.documentName, arrow: true, children: _jsx(Typography, { variant: 'body1', color: theme.palette.text.primary, sx: {
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '200px',
                                                                display: 'block'
                                                            }, children: file.documentName }) }) })] }) }), _jsx(Grid, { size: { xs: 12, md: 4 }, display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'flex-end', children: _jsx(IconButton, { onClick: () => downloadDocument(file.documentName, file.documentPath, file.documentId), sx: {
                                                backgroundColor: theme.palette.primary.main,
                                                color: theme.palette.primary.contrastText,
                                                '&:hover': {
                                                    backgroundColor: theme.palette.primary.dark
                                                }
                                            }, children: _jsx(Download04Icon, { size: 20 }) }) })] }, file.documentId))) }) }) }) })] }));
}
export default KnowledgeBaseDocumentPopUp;
